import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PwaPushNotificationEffects } from './effects/pwa-push-notification.effects';
import { pwaPushNotificationReducer } from './reducers/pwa-push-notification.reducer';
import { PWA_PUSH_NOTIFICATION_FEATURE_KEY } from './pwa-push-notification.state';

/**
 * Registers the PWA push-notification feature slice. `PwaPushNotificationNgrxService.init()`
 * loads the persisted subscription choice via {@link PwaPushNotificationEffects}; saving a new
 * choice (offered/subscribed) updates the slice and is mirrored to storage by the same effects.
 *
 * Deliberately not registered under `PERSISTED_SLICES`: that generic mechanism persists through
 * `ConcurrentUsageService`, a cross-device sync store keyed per gid — correct for genuinely
 * cross-device data (e.g. timesheets), but wrong for a push subscription, which is inherently
 * per-device. `PwaPushNotificationEffects` persists directly to
 * `PwaPushNotificationsLocalStorageService` (device-local) instead.
 */
@NgModule({
    imports: [
        StoreModule.forFeature(PWA_PUSH_NOTIFICATION_FEATURE_KEY, pwaPushNotificationReducer),
        EffectsModule.forFeature([PwaPushNotificationEffects]),
    ],
})
export class PwaPushNotificationStoreModule {}
